import { Link } from "react-router";

import { describeIngestionRule } from "@/shared/domain/ingestionRules";
import { useIngestionRules } from "@/shared/domain/ingestionRules/hooks";
import { Goto } from "@/shared/navigation";

import {
  managedByRuleExplanation,
  useIngestionRuleName,
} from "./managedByIngestionRule";

/** Why a rule-owned trigger is not edited here, with a link to its rule. */
export function ManagedByIngestionRuleNote({
  ruleId,
  id,
  className,
}: {
  ruleId: string;
  id?: string;
  className?: string;
}) {
  const ruleName = useIngestionRuleName(ruleId);
  return (
    <p
      className={className}
      id={id}
      data-testid="managed-by-ingestion-rule-note"
    >
      {managedByRuleExplanation(ruleName)}{" "}
      <Link to={Goto.createIngestionRuleRoute(ruleId)}>Open the rule</Link>
    </p>
  );
}

/** What the owning rule does, in one sentence, once the org's rules have loaded. */
export function ManagingRuleSummary({
  ruleId,
  className,
}: {
  ruleId: string;
  className?: string;
}) {
  const rules = useIngestionRules();
  const rule = rules.data?.find((candidate) => candidate.rule_id === ruleId);
  if (rule === undefined) {
    return null;
  }
  return (
    <p className={className} data-testid="managing-rule-summary">
      {describeIngestionRule(rule)}
    </p>
  );
}
